module.exports = __webpack_public_path__ + "img/Case_12.0e7b7186.jpg";